import { FaFacebookF, FaInstagram, FaArrowRight } from "react-icons/fa";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 w-full relative">
        {/* Center Image */}
        <div className="hidden lg:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-0">
          <div className="w-[700px] h-[700px] rounded-full overflow-hidden bg-gray-100">
            <img
              src="/images/profile.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="relative z-10 grid lg:grid-cols-[320px_1fr_320px] items-center min-h-screen">
          {/* LEFT */}

          <div>
            <p className="text-6xl font-light mb-2">I'm</p>

            <h1 className="text-7xl xl:text-[100px] leading-none font-black">
              Taikhoom
              <br />
              Amir
            </h1>

            <div className="w-64 h-2 bg-red-600 mt-8 mb-10"></div>

            <p className="text-gray-700 text-xl leading-10">
              5 years in this dynamic industry proved to us that nothing is
              irreplaceable. On the contrary, I also learned how to make a
              lasting impression through my work and ethics. That to me is the
              biggest achievement.
            </p>
          </div>

          {/* CENTER */}
          <div></div>

          {/* <div className="flex justify-center">
            <div className="relative">
              <div className="w-[700px] h-[700px] rounded-full overflow-hidden bg-gray-100">
                <img
                  src="/images/profile.jpg"
                  alt=""
                  className="w-full h-full object-cover -z-1"
                />
              </div>
            </div>
          </div> */}

          {/* RIGHT */}

          <div>
            <h3 className="text-5xl font-bold mb-8">Services</h3>

            <p className="text-gray-700 text-xl leading-10 mb-10">
              My portfolio consists of projects with more than 500+ brands both
              big and currently establishing ones.
            </p>

            <button className="flex items-center gap-4 text-red-600 text-2xl font-medium hover:gap-6 transition-all">
              Show more
              <FaArrowRight />
            </button>

            <div className="flex gap-6 mt-14">
              <a
                href="/"
                className="w-16 h-16 rounded-full bg-black text-white flex items-center justify-center text-2xl hover:bg-red-600 transition"
              >
                <FaFacebookF />
              </a>

              <a
                href="/"
                className="w-16 h-16 rounded-full bg-black text-white flex items-center justify-center text-2xl hover:bg-red-600 transition"
              >
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
